import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DtoPoint from '../../dto/DtoPoint'
import QualityPanel from './quality/QualityPanel'
import SiteTypes from '../../../utils/mapUtils/SiteTypes'
import i18n from 'simple-react-i18n'

class TypePointPanel extends Component {
	constructor(props) {
		super(props)
	}

	getDefaultPanel = () => {
		return (
			<div className='row no-margin'>
				<div className='col s12 no-padding font-size-20'>
					{ i18n.warning.noInformationAvailable }
				</div>
			</div>
		)
	}

	getData = () => {
		switch (this.props.parameter) {
			case SiteTypes.QUALITOMETER.type:
			case SiteTypes.QUALITOMETER_SURFACE.type:
				return (<QualityPanel />)
			default:
				return this.getDefaultPanel()
		}
	}


	render() {
		return (
			<div className='row no-margin'>
				<div className='col s12 no-padding'>
					{ this.getData() }
				</div>
			</div>
		)
	}
}

TypePointPanel.propTypes = {
	point: PropTypes.objectOf(DtoPoint),
	parameter: PropTypes.string
}
const mapStateToProps = store => {
	return {
		siteTypes: store.ReferentialReducer.siteTypes,
		point: store.PointReducer.point
	}
}

export default connect(mapStateToProps)(TypePointPanel)



// WEBPACK FOOTER //
// ./src/point/components/pointType/TypePointPanel.js